import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Logo } from './types/logo.type';
import { ImageComponent } from '../image/image.component';
import { ThemeService } from "../../../core/services/theme.service";
import { AppDataService } from '../../../core/services/app-data.service';

@Component({
    selector: 'berry-logo',
    standalone: true,
    imports: [CommonModule, ImageComponent],
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss'
})
export class LogoComponent {
    public readonly _appData: AppDataService = inject(AppDataService);

    @Input() style: Logo = 'small';
    @Input() maxHeight: number = 200;
    @Input() maxWidth: number = 400;

    @Input() type: 'login' | 'system' = 'system';

    darkMode = false;

    get clientName() {
        return this._appData.configurations.clientName;
    }
    constructor(public themeService: ThemeService) {
        themeService.isDarkMode.subscribe({
            next: (isDarkMode) => {
                {
                    this.darkMode = isDarkMode;
                }
            }
        })
    }
    public get logo(): string {
        return this.type == 'login' ? this.getLoginLogo() : this.getSystemLogo();

    }
    public get darkLogo(): string {
        return this.type == 'login' ? this.getDarkLoginLogo() : this.getDarkSystemLogo();
    }

    getLoginLogo() {
        if ((this.themeService.showThemeDialog || this.themeService.logoChanged))
            return this.themeService.themeData.LogoLogin?.startsWith('data:image') ? this.themeService.themeData.LogoLogin : 'data:image/png;base64,' + this.themeService.themeData.LogoLogin;

        else
            return this._appData.configurations.logoLogin?.lightImage?.startsWith('data:image') ? this._appData.configurations.logoLogin?.lightImage : 'data:image/png;base64,' + this._appData.configurations.logoLogin?.lightImage;

    }
    getDarkLoginLogo() {
        if ((this.themeService.showThemeDialog || this.themeService.logoChanged))
            return this.themeService.themeData.darkLogoLogin?.startsWith('data:image') ? this.themeService.themeData.darkLogoLogin : 'data:image/png;base64,' + this.themeService.themeData.darkLogoLogin;

        else
            return this._appData.configurations.logoLogin?.darkImage?.startsWith('data:image') ? this._appData.configurations.logoLogin?.darkImage : 'data:image/png;base64,' + this._appData.configurations.logoLogin?.darkImage;

    }
    getSystemLogo() {
        if ((this.themeService.showThemeDialog || this.themeService.logoChanged) && !this.themeService.previewLoginPage)
            return this.themeService.themeData.logoImagePath?.startsWith('data:image') ? this.themeService.themeData.logoImagePath : 'data:image/png;base64,' + this.themeService.themeData.logoImagePath;

        else
            return this._appData.configurations.logoLogin?.lightImage?.startsWith('data:image') ? this._appData.configurations.logoImagePath?.lightImage : 'data:image/png;base64,' + this._appData.configurations.logoImagePath?.lightImage;

    }

    getDarkSystemLogo() {
        if ((this.themeService.showThemeDialog || this.themeService.logoChanged) && !this.themeService.previewLoginPage)
            return this.themeService.themeData.logoImageDark?.startsWith('data:image') ? this.themeService.themeData.logoImageDark : 'data:image/png;base64,' + this.themeService.themeData.logoImageDark;

        else
            return this._appData.configurations.logoLogin?.darkImage?.startsWith('data:image') ? this._appData.configurations.logoImagePath?.darkImage : 'data:image/png;base64,' + this._appData.configurations.logoImagePath?.darkImage;

    }


    public get previewlogo(): string {
        if (this.darkMode)
            return this.themeService.themeData.darkLogoLogin?.startsWith('data:image') ? this.themeService.themeData.darkLogoLogin : 'data:image/png;base64,' + this.themeService.themeData.darkLogoLogin;
        else
            return this.themeService.themeData.LogoLogin?.startsWith('data:image') ? this.themeService.themeData.LogoLogin : 'data:image/png;base64,' + this.themeService.themeData.LogoLogin;

    }

}
